// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__15B6p","bigColWidth":"Table_bigColWidth__30Ec6","biggerColWidth":"Table_biggerColWidth__1C5VI","row":"Table_row__q9l7Q","col":"Table_col__2fZUM"};